import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Form,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
} from "react-bootstrap";
import moment from "moment";
import useSessionStorage from "../../../hooks/useSessionStorage";
import requestUtil from "../../../helpers/requestUtil";
import useConfiguration from "../../../hooks/useConfiguration";
import { toast } from "react-toastify";
import EmailReply from "./emailReply";
import ToolTip from "../ToolTip/ToolTip";
import { ImAttachment } from "react-icons/im";
const EmailModal = ({
  showModal,
  data,
  handleSave,
  handleClose,
  formData,
  handleForm,
  listData,
  sendAllEmail,
  sendReadEmail,
  groupEmailSaveFlag,
  emailHistoryMainPageFlag,
}) => {
  const regex = /(<([^>]+)>)/gi;
  const storage = useSessionStorage();
  const login = storage.getItem("login");
  const config = useConfiguration();
  const [sessionUniqueId, setSessionUniqueId] = useState("");
  const [replyModal, setReplyModal] = useState({ flag: false, id: "", data: {} });
  const [mainHistoryToggle, setMainHistoryToggle] = useState(false);
  const [childHistoryToggle, setChildHistoryToggle] = useState('');


  const generate_uuidv4 = () => {
    var dt = new Date().getTime();
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var rnd = Math.random() * 16; //random number in range 0 to 16
        rnd = (dt + rnd) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === "x" ? rnd : (rnd & 0x3) | 0x8).toString(16);
      }
    );
  };


  useEffect(() => {
    // setTimeout(() => window.enableEmailSummaryNote(), 0);
    window.enableEmailSummaryNote();
    setSessionUniqueId(generate_uuidv4());
  }, [showModal]);

  function emailTimeDisplay(dbDate) {
    dbDate = new moment(dbDate);
    let currentDate = new moment();
    if (currentDate.isSame(dbDate, "day")) {
      return dbDate.format("h:mm a");
    } else if (currentDate.isSame(dbDate, "year")) {
      return dbDate.format("MMM DD");
    } else {
      return dbDate.format("MM/DD/YYYY");
    }
  }

  const [fileInputs, setFileInputs] = useState([]);

  const addFileInput = () => {
    setFileInputs([
      ...fileInputs,
      { id: Date.now(), file: null, fileName: "" },
    ]);
  };

  const removeFileInput = async (id, canTrackId) => {
    const updatedInputs = fileInputs.filter((input) => input.id !== id);
    setFileInputs(updatedInputs);
    if (config.baseUrl && canTrackId) {
      await requestUtil(
        `${config.baseUrl}/Messaging/delete-candidates-files-tracking-document`,
        "DELETE",
        canTrackId
      );
    }
  };

  const fileChange = async (e, inputId) => {
    const candidateUniqueId =
      data?.length && data?.map((item) => item?.candidateUniqueId).join(",");

    const file = e.target.files[0];

    const formdata = new FormData();
    formdata.append("File", file);
    formdata.append(
      "CandidateUniqueId",
      groupEmailSaveFlag ? candidateUniqueId : candidateUniqueId
    );
    formdata.append("EmployerUniqueId", login.employerUniqueId);
    formdata.append("SessionId", sessionUniqueId);

    if (config.baseUrl) {
      try {
        const data = await requestUtil(
          `${config.baseUrl}/Messaging/fileuploadwithtracking`,
          "POST",
          formdata,
          null,
          true
        );
        setFileInputs((prevFileInputs) => {
          return prevFileInputs.map((input) =>
            input.id === inputId
              ? {
                ...input,
                file: file,
                fileName: file ? data?.map((item) => item?.attachedFilename) : "",
                canTrackId: data?.map(
                  (item) => item?.candidateFileTrackingId
                ),
              }
              : input
          );
        });
      } catch (error) {
        toast.error("Invalid file format");
      }
    }
  };

  const downloadUploadDoc = async (filename, docId, { url }) => {
    const requestHeaders = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
    };
    fetch(`${config.baseUrl}/${url}${JSON.stringify(docId)}`, {
      headers: requestHeaders,
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
  };

  const fileDownloadUploadDoc = async (filename, docId, { url }) => {
    const queryString = docId
      .map((id) => `CandidateFileTrackingId=${id}`)
      .join("&");
    const requestHeaders = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: login.accessToken ? `Bearer ${login.accessToken}` : "",
    };
    fetch(`${config.baseUrl}/${url}${queryString}`, {
      headers: requestHeaders,
    }).then((response) => {
      response.blob().then((blob) => {
        let url = window.URL.createObjectURL(blob);
        let a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
      });
    });
  };

  const openReplyModal = (id, val) => {
    if (id && val) {
      setReplyModal({ flag: true, id: id, data: val });
    }
  };

  const closeReplyModal = () => {
    setReplyModal({ flag: false, id: "", data: {} });
  };

  return (
    <>
      <EmailReply
        showModal={replyModal.flag}
        closeModal={closeReplyModal}
        candidateUniqueId={replyModal.id}
        data={replyModal.data}
      />
      <div id="userLocationModal">
        <Modal size="lg" show={showModal}>
          <Modal.Header >
            <Modal.Title>Compose Mail</Modal.Title>

            <div className="d-flex gap-4">
              {/* <i
                class="fa fa-envelope-open"
                type="button"
                onClick={() => sendReadEmail()}
              ></i> */}
              <i
                class="fa fa-close fa-lg"
                type="button"
                // onClick={() => sendAllEmail()}
                onClick={() => {
                  handleClose();
                  setFileInputs([]);
                  setMainHistoryToggle(false);
                  setChildHistoryToggle(!childHistoryToggle === 'index')
                }}
              ></i>
            </div>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-sm-12">
                <form>
                  <div className="form-group">
                    <label htmlFor="from-candidate">
                      From Employer<span class="required">*</span>
                    </label>
                    <div>
                      {
                        login?.employerSupportEmailFromName
                      }
                    </div>
                    <label htmlFor="to-candidate" className="mt-3">
                      To Candidate<span class="required">*</span>
                    </label>
                    <div>
                      {emailHistoryMainPageFlag === true ? (
                        <>
                          <span>{data?.candidateName}</span>
                          <span>{`<${data?.candidateEmail}>`}</span>
                        </>
                      ) : data && data.length ? (
                        data.map((item, index) => {
                          return (
                            <span key={index}>
                              {item?.candidateName || item?.name ||
                                `${item?.candidateFirstName} ${item?.candidateLastName}`}{" "}
                              &lt;{item?.email}&gt;
                              {index + 1 !== data.length && ","}
                            </span>
                          );
                        })
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <Row>
                    <Form.Group as={Col} className="md-6" controlId="subject">
                      <Form.Label>
                        Subject<span class="required">*</span>
                      </Form.Label>
                      <Form.Control
                        type="text"
                        value={formData?.subject}
                        onChange={(e) => {
                          handleForm("subject", e.currentTarget.value);
                        }}
                        placeholder="Subject"
                      />
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} className="md-6" controlId="email">
                      <label htmlFor={"emailSummaryNote"}>Email</label>
                      <div
                        id="emailSummaryNote"
                        dangerouslySetInnerHTML={{
                          __html: "",
                        }}
                      ></div>
                    </Form.Group>
                  </Row>
                </form>

                <div className="row mt-3 mb-3">
                  <div className="col-10" style={{overflowWrap: 'break-word'}}>
                    {fileInputs?.map((input, index) => (
                      <div key={input.id} className="d-flex gap-3">
                        {!input.fileName && (
                          <input
                            className="mb-3 form-control"
                            type="file"
                            onChange={(e) => fileChange(e, input.id)}
                          />
                        )}

                        <div className="col mt-3">
                          <div className="row">
                            <div className="col-11">
                            {input.fileName && (
                              <span
                                onClick={() =>
                                  fileDownloadUploadDoc(
                                    input?.fileName,
                                    input?.canTrackId,
                                    {
                                      url: "Messaging/download-candidates-files-tracking-document?",
                                    }
                                  )
                                }
                                style={{ cursor: "pointer" }}
                                rel="noreferrer"
                                target="_blank"
                                className="col-11"
                              >
                                <i>{input.fileName[0]} -</i>
                                <i
                                  className="mdi mdi-arrange-bring-forward"
                                  data-bs-toggle="tooltip"
                                  title=""
                                  data-bs-original-title="mdi-arrange-bring-forward"
                                  aria-label="mdi-arrange-bring-forward"
                                ></i>
                              </span>
                            )}
</div>
                            <div className="col-1">
                              <i
                                onClick={() =>
                                  removeFileInput(input.id, input.canTrackId)
                                }
                                className="fe fe-trash-2 fa-lg text-danger mt-2 "
                                style={{ cursor: "pointer" }}
                              ></i>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <span onClick={addFileInput} className="d-flex">
                      <i
                        className="icon-2x icon-plus mt-3 text-info"
                        data-bs-toggle="tooltip"
                        title=""
                        data-bs-original-title="icon-plus"
                        aria-label="Add Work History"
                      ></i>
                      <div
                        style={{ marginLeft: "0.5rem", cursor: "pointer" }}
                        className="mt-2 text-info"
                      >
                        Add Attachment
                      </div>
                    </span>
                  </div>

                  <div className="col-2">
                    <Button
                      variant="primary"
                      onClick={() => {
                        handleSave(sessionUniqueId);
                        setFileInputs([]);
                      }}
                    >
                      Send Email
                    </Button>
                  </div>
                </div>

                {listData && listData?.length ? (
                  <>
                    <div className="accordion" id="accordionExample">
                      <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                          <button
                            class="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseOne"
                            aria-expanded="false"
                            aria-controls="collapseOne"
                            onClick={() => setMainHistoryToggle(!mainHistoryToggle)}
                          >
                            Email History
                          </button>
                        </h2>
                        {mainHistoryToggle &&
                          <div
                          // id="collapseOne"
                          // class="accordion-collapse collapse"
                          // aria-labelledby="headingOne"
                          // data-bs-parent="#accordionExample"
                         style={listData?.length <  5 ? {} : {height: '500px', overflow: 'scroll'}}
                          >

                            <div class="accordion-body">
                              <div class="table-responsive">
                                <table class="table table-inbox table-hover text-nowrap mb-0">
                                  <tbody>
                                    {listData?.map((element, index) => {
                                      const result = (
                                        <p
                                          dangerouslySetInnerHTML={{
                                            __html: element?.messageSubject
                                            ,
                                          }}
                                        ></p>
                                      );
                                      const val = element?.messageBody
                                        ?.split(/\n/)
                                        .map((line) => (
                                          <React.Fragment key={line}>
                                            {line.replace(regex, "")}
                                            <br />
                                          </React.Fragment>
                                        ));
                                      return (
                                        <>
                                          <tr
                                            style={element?.fromCandidate ? { backgroundColor: '#FFD300' } : {}}
                                            onClick={() => setChildHistoryToggle(index)}
                                            className={
                                              `
                                            collapsed
                                             ${element.fromCandidate &&
                                              ""
                                              }`}
                                          // data-bs-toggle="collapse"
                                          // data-bs-parent="#accordion"
                                          // href={`#data_${index}`}
                                          // aria-expanded="false"
                                          // aria-controls={`data_${index}`}
                                          >
                                            <td class="view-message dont-show fw-semibold clickable-row">
                                              {element.messageFrom}
                                            </td>
                                            <td
                                              class="view-message clickable-row text-truncate"
                                              style={{ maxWidth: "150px" }}
                                            >
                                              <ToolTip
                                                position={"bottom"}
                                                value={result}
                                              >
                                                <p>{element.messageSubject}</p>
                                              </ToolTip>
                                            </td>
                                            <td>
                                              {parseInt(element.sentStatus) ===
                                                0 ? (
                                                <i
                                                  class="fa fa-arrow-up"
                                                  style={{ color: "orange" }}
                                                  title="In Queue"
                                                ></i>
                                              ) : parseInt(element.sentStatus) ===
                                                1 ? (
                                                <i
                                                  class="fa fa-check"
                                                  style={{ color: "green" }}
                                                  title="Success"
                                                ></i>
                                              ) : parseInt(element.sentStatus) ===
                                                2 ? (
                                                <i
                                                  class="fa fa-info-circle"
                                                  style={{ color: "red" }}
                                                  title="Failed"
                                                ></i>
                                              ) : parseInt(element.sentStatus) ===
                                                3 ? (
                                                <i
                                                  class="fa fa-exclamation-triangle"
                                                  style={{ color: "red" }}
                                                  title="Error"
                                                ></i>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {element.fromCandidate ? (
                                                <span
                                                  onClick={() =>
                                                    openReplyModal(
                                                      element?.candidateUniqueId,
                                                      {
                                                        messageTrackingId: element?.messageTrackingId,
                                                        messageSubject: element?.messageSubject,
                                                        messageBody: element?.messageBody,
                                                        messageFrom: element?.messageFrom,
                                                        messageTo: element?.messageTo,
                                                        messageDate: element?.messageDate,
                                                        fromName: element?.messageFromName,
                                                        toName: element?.messageToName
                                                      }
                                                    )
                                                  }
                                                >
                                                  <i className="fa fa-reply fa-lg" style={{color: '#004D40'}}></i>
                                                </span>
                                              ) : (
                                                ""
                                              )}
                                            </td>
                                            <td>
                                              {element?.ticketNo}
                                            </td>
                                            <td class="view-message text-end fw-semibold clickable-row">
                                              {moment(element.messageDate).format(
                                                "MM-DD-YYYY hh:mm A"
                                              )}
                                              {/* {emailTimeDisplay(element.messageDate)} */}
                                            </td>
                                          </tr>

                                          <tr className="bg-white">


                                            {childHistoryToggle === index &&
                                              <td
                                                // id={`data_${index}`}
                                                // class="panel-collapse collapse text-wrap"
                                                // role="tabpanel"
                                                // aria-labelledby={`data_${index}`}
                                                className="text-wrap"
                                                colSpan={6}
                                              >
                                                {/* <>{val}</> */}

                                    <>
                                        <span className='ms-2'>From: {`${element?.messageFromName}<${element?.messageFrom}>`}</span> <br />
                                        <span className='ms-2'>Sent: {moment().format('LLLL')}</span> <br />
                                        <span className='ms-2'>To: {`${element?.messageToName} <${element?.messageTo}>`}</span> <br />
                                        <span className='ms-2'>Subject: {element?.messageSubject}</span><br />
                                    </>
                                                  <div
                                                  className="mt-3"
                                                  dangerouslySetInnerHTML={{
                                                    __html: element?.messageBody,
                                                  }}
                                                ></div>

                                          {element?.messageTrackingAttachments
                                                  ?.length > 0
                                                  ? element?.messageTrackingAttachments?.map(
                                                    (item) => {
                                                      return (
                                                        <div
                                                          className="d-flex flex-column gap-2 mt-2"
                                                          rel="noreferrer"
                                                          style={{
                                                            cursor: "pointer",
                                                            marginBottom:"1rem",
                                                            marginRight:"1rem",
                                                            display:"inline-block"
                                                          }}
                                                          onClick={() =>
                                                            downloadUploadDoc(
                                                              item?.attachedFilename,
                                                              item?.messageTrackingAttachmentId,
                                                              {
                                                                url: "Messaging/download-Message-file-tracking-document?MessageTrackingAttachmentId=",
                                                              }
                                                            )
                                                          }

                                                        >
                                                          <i className="text-primary">
                                                           <ImAttachment/>-{item?.attachedFilename}-<i
                                                            className="mdi mdi-arrange-bring-forward text-primary"
                                                            data-bs-toggle="tooltip"
                                                            title=""
                                                            data-bs-original-title="mdi-arrange-bring-forward"
                                                            aria-label="mdi-arrange-bring-forward"
                                                          ></i>
                                                          </i>
                                                        </div>
                                                      );
                                                    }
                                                  )
                                                  : ""}

                                              </td>}

                                          </tr>




                                        </>
                                      );
                                    })}
                                  </tbody>
                                </table>
                              </div>
                            </div>


                          </div>
                        }
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              className="btn btn-outline-primary"
              onClick={() => {
                handleClose();
                setFileInputs([]);
                setMainHistoryToggle(false);
                setChildHistoryToggle(!childHistoryToggle === 'index')
              }}
            >
              Close
            </button>
            {/* <Button
              variant="white"
             
            >
             
            </Button> */}
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};

export default EmailModal;
